const MatchType = {
  Quota: 0,
  StrokePlayNet: 1,
  StrokePlayGross: 2,
  MatchPlayGross: 3,
  SkinsGross: 4,
  SkinsNet: 5,
  BirdiePoolGross: 6,
  BirdiePoolNet: 7,
  MatchPlayNet: 8
};

const MatchTypes = {
  0: "Quota",
  1: "Stroke Play (Net)",
  2: "Stroke Play Gross",
  3: "Match Play Gross",
  4: "Skins Gross",
  5: "Skins (Net)",
  6: "Birdie Pool Gross",
  7: "Birdie Pool (Net)",
  8: "Match Play (Net)"
};

export { MatchType, MatchTypes };
